'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.endpointConstructor = exports.domain = exports.getIconsFromBucket = exports.getYusenIcons = exports.getSellerProfileLogo = exports.getSellerProfileLogoMemoized = exports.getFeStaticBucket = exports.getMsEndpointUrl = exports.buildMSEndpointURL = exports.getMSBaseDomain = exports.isTestEnv = exports.isLocalEnv = exports.getUploadedFileUrl = exports.getEndpoint = exports.getEnvDomain = exports.getEnvDomainFromURL = exports.getRootDomain = exports.getTLD = exports.getSubdomain = exports.getDomain = undefined;

var _parseDomain = require('parse-domain');

var _parseDomain2 = _interopRequireDefault(_parseDomain);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _memoize = require('lodash/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _template = require('lodash/template');

var _template2 = _interopRequireDefault(_template);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _startsWith = require('lodash/startsWith');

var _startsWith2 = _interopRequireDefault(_startsWith);

var _endsWith = require('lodash/endsWith');

var _endsWith2 = _interopRequireDefault(_endsWith);

var _trimEnd = require('lodash/trimEnd');

var _trimEnd2 = _interopRequireDefault(_trimEnd);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _constants = require('./constants');

var constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MICROSERVICES_DOMAINS = constants.MICROSERVICES_DOMAINS,
    BASE_TEST_URL = constants.BASE_TEST_URL,
    SELLER_PROFILES_LOGOS_BUCKET = constants.SELLER_PROFILES_LOGOS_BUCKET,
    YUSEN_ICONS = constants.YUSEN_ICONS;
var getDomain = exports.getDomain = function getDomain(url) {
  var parsedDomain = (0, _parseDomain2.default)(url);
  if (parsedDomain) {
    return _parseDomain2.default.domain;
  }
  return null;
};

var getSubdomain = exports.getSubdomain = function getSubdomain(url) {
  var customTlds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var parsedDomain = (0, _parseDomain2.default)(url, customTlds);
  if (parsedDomain) {
    return parsedDomain.subdomain;
  }
  return null;
};

var getTLD = exports.getTLD = function getTLD(url) {
  var parsedDomain = (0, _parseDomain2.default)(url);
  if (parsedDomain) {
    return _parseDomain2.default.tld;
  }
  return null;
};

var getRootDomain = exports.getRootDomain = function getRootDomain(url) {
  var parsedDomain = (0, _parseDomain2.default)(url, { customTlds: /localhost|\.local/ });
  if (parsedDomain) {
    return parsedDomain.domain + '.' + parsedDomain.tld;
  }
  return null;
};

// TODO remove this code once we released Mercado
var getEnvDomainFromURL = exports.getEnvDomainFromURL = function getEnvDomainFromURL(url) {
  var domain = getRootDomain(url) || '';

  // To support feightos.com, freightos.cn
  // For non default builds (appspot.com) should return freightos dns not the appspot domain
  if (domain.toLowerCase() !== 'appspot.com') {
    return domain;
  }

  /**
   * We need to be able to call our microservices from appspot hosted sites as we
   * use them during CI/acceptance.
   */
  var hostname = window.location.hostname.toLowerCase();
  if (hostname.indexOf('test') !== -1) {
    return 'test-freightos.com';
  }

  return 'freightos.com';
};

// TODO remove this code once we released Mercado
var getEnvDomain = exports.getEnvDomain = function getEnvDomain() {
  var url = window.location.href;
  return getEnvDomainFromURL(url);
};

var getEndpoint = exports.getEndpoint = function getEndpoint() {
  var location = window.location.href;
  var domain = getRootDomain(location) || '';
  if (domain.includes('local')) {
    var siteName = getSubdomain(location, { customTlds: ['local'] }) || 'ship';

    var port = window.localStorage.getItem('proxy') || '8888';

    return 'http://' + siteName + '.freightos.local:' + port + '/';
  }
  return '/';
};

var getUploadedFileUrl = exports.getUploadedFileUrl = function getUploadedFileUrl(filePath) {
  var server = getEndpoint();
  if (server === '/') {
    return filePath;
  }
  if ((0, _endsWith2.default)(server, '/') && (0, _startsWith2.default)(filePath, '/')) {
    return '' + (0, _trimEnd2.default)(server, '/') + filePath;
  }
  return '' + server + filePath;
};

var isLocalEnv = exports.isLocalEnv = function isLocalEnv() {
  var location = window.location.href;
  var domain = getRootDomain(location) || '';

  return domain.includes('local');
};

var isTestEnv = exports.isTestEnv = function isTestEnv() {
  var location = window.location.href;
  var domain = getRootDomain(location) || '';

  return domain.includes('test');
};

var getMSBaseDomain = exports.getMSBaseDomain = function getMSBaseDomain() {
  var domain = getRootDomain(window.location.href) || '';

  // To support feightos.com, freightos.cn
  // For non default builds (appspot.com) should return freightos dns not the appspot domain
  if (!domain.toLowerCase().includes('appspot.com')) {
    return domain;
  }

  /**
   * We need to be able to call our microservices from appspot hosted sites as we
   * use them during CI/acceptance.
   */
  var hostname = (0, _get2.default)(window, 'location.hostname');
  if (hostname) {
    var nonDefaultURL = constants.NON_DEFAULT_INFIX_ENVIRONMENT_MAP.filter(function (nonDefaultInfix) {
      return hostname.toLowerCase().includes('' + nonDefaultInfix.urlInfix + constants.NON_DEFAULT_URL_ENVIRONMENT_PREFIX);
    });

    if (nonDefaultURL && nonDefaultURL.length > 0) {
      return nonDefaultURL[0].environmentDomain;
    }
  }
  return constants.TEST1_ENV.environmentDomain;
};

var buildMSEndpointURL = exports.buildMSEndpointURL = function buildMSEndpointURL(urlPrefix, localPort) {
  var allowLocal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var baseURL = '' + getMSBaseDomain();

  // when called from a local environment
  if (baseURL.includes(constants.LOCAL_ENV_SUFFIX)) {
    // default behavior on a local environment is to use the test env MS endpoints
    baseURL = allowLocal ? baseURL : BASE_TEST_URL;
    var hyperTextProtocol = allowLocal ? 'http://' : 'https://';

    var msURL = '' + hyperTextProtocol + urlPrefix + '.' + baseURL;

    if (localPort && allowLocal) {
      return msURL + ':' + localPort;
    }
    return msURL;
  }

  return 'https://' + urlPrefix + '.' + baseURL;
};

var getMsEndpointUrl = exports.getMsEndpointUrl = function getMsEndpointUrl(msName, urlPrefix, localPort, apiPath, apiVersion, msDomain) {
  var defaultParams = (0, _find2.default)(MICROSERVICES_DOMAINS, { NAME: msName });

  if (!defaultParams) {
    return '';
  }
  var shouldRunLocally = void 0;
  try {
    var msRunLocal = process.env.MS_RUN_LOCAL;
    // MS_RUN_LOCAL && __DEV_SERVER__ are params defined by a webpack plugin.
    shouldRunLocally = !(0, _isUndefined2.default)(msRunLocal) && __DEV_SERVER__ ? msRunLocal.includes && msRunLocal.includes(msName) : false;
  } catch (e) {
    // Force logging the exception
    console.log(e);
    shouldRunLocally = false;
  }
  var prefix = urlPrefix || defaultParams.DEFAULT_URL_PREFIX;
  var port = localPort || defaultParams.DEFAULT_LOCAL_PORT;
  var version = apiVersion || defaultParams.DEFAULT_API_VERSION;
  var apiUrl = apiPath || defaultParams.DEFAULT_API_PATH;
  var domain = msDomain || defaultParams.DEFAULT_MS_DOMAIN;
  var api = apiUrl ? '/' + apiUrl + '/' + version : '';
  var sufix = domain ? '/' + domain : '';

  return buildMSEndpointURL(prefix, port, shouldRunLocally) + api + sufix;
};

var getFeStaticBucket = exports.getFeStaticBucket = function getFeStaticBucket() {
  var test = isTestEnv() || isLocalEnv() ? 'test-' : '';
  return 'https://festatic.' + test + 'freightos.com';
};

var getSellerProfileLogoMemoized = exports.getSellerProfileLogoMemoized = function getSellerProfileLogoMemoized(businessKey) {
  return '' + getFeStaticBucket() + SELLER_PROFILES_LOGOS_BUCKET + businessKey + '/en.png?' + new Date().getTime();
};

var getSellerProfileLogo = exports.getSellerProfileLogo = (0, _memoize2.default)(getSellerProfileLogoMemoized);

var getYusenIcons = exports.getYusenIcons = function getYusenIcons(icon) {
  return '' + getFeStaticBucket() + YUSEN_ICONS + icon;
};

var getIconsFromBucket = exports.getIconsFromBucket = function getIconsFromBucket(bucketPath, icon) {
  return getFeStaticBucket() + '/' + bucketPath + '/icons/' + icon;
};

var domain = exports.domain = function domain() {
  var uri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

  var url = uri || document.location.origin;

  if (url.includes('freightos.cn')) {
    return 'freightos.cn';
  }

  if (url.includes('test-') || url.includes('tradeos-test1.appspot.com')) {
    return 'test-freightos.com';
  }

  return 'freightos.com';
};

var endpointConstructor = exports.endpointConstructor = function endpointConstructor(tpl, params) {
  return (0, _template2.default)(tpl)(params);
};